import { createSelector } from 'reselect';
import { OpenDrawerParams } from 'types/drawers';
import { DrawersState as State } from './types';

const activeDrawersSelector = (state: State) => state.activeDrawers;

// eslint-disable-next-line import/prefer-default-export
export const activeDrawerDataSelector = createSelector(
  activeDrawersSelector,
  (activeDrawerParams) => {
    const result: OpenDrawerParams[] = [];

    if (activeDrawerParams && activeDrawerParams.length) {
      result.push(...activeDrawerParams);
    }

    return result;
  },
);
